import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import { PDF_VIEWER_PINCH_ZOOM_DISABLE } from '@app/libs/reactPdfJs/store/actionTypes';

export type PdfPinchZoomDisabled = boolean;

const initialState: PdfPinchZoomDisabled = false;

export default function reducer(state: PdfPinchZoomDisabled = initialState, action: PdfAction) {
  switch (action.type) {
    case PDF_VIEWER_PINCH_ZOOM_DISABLE:
      return action.payload;
    default:
      return state;
  }
}
